import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,_vm._g(_vm._b({staticClass:"vd-header-menu-btn",class:_vm.spacing,attrs:{"aria-label":_vm.menuBtnActionLabel}},'VBtn',{
		..._vm.options.btn,
		..._vm.$attrs
	},false),_vm.$listeners),[_c(VIcon,_vm._b({},'VIcon',_vm.options.icon,false),[_vm._v(" "+_vm._s(_vm.menuIcon)+" ")]),_vm._v(" "+_vm._s(_vm.locales.menu)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }